import { setDefaultOptions } from "date-fns"
import ptBR from "date-fns/locale/pt-BR"

setDefaultOptions({ locale: ptBR })
